import React, {useCallback} from "react";
import {Route, Switch, useRouteMatch} from "react-router";
import {PatientRouteSettings} from "./PatientRouteSettings";
import {removeTrailingSlash} from "fe-common/routes/removeTrailingSlash";
import {useWidgetSettings} from "../widget/useWidgetSettings";
import {PatientRoute} from "./PatientRoute";
import {Slide} from "@mui/material";

//region [[ Props ]]
export interface PatientFacingRouterProps {
  embedded?: boolean;
}

//endregion [[ Props ]]
export const PatientFacingRouter = React.memo(
  ({ embedded }: PatientFacingRouterProps) => {
    const match = useRouteMatch();

    const { termsAgreed } = useWidgetSettings();

    // Clean "/" from path in the end if exists
    const matchPath = removeTrailingSlash(match.path);

    const pathByIndex = useCallback(
      (patientRoute, index) =>
        (index === 0 && !termsAgreed) || // If terms agreed, make sure questions is the first route
        (termsAgreed && patientRoute.route === PatientRoute.Questions)
          ? [
              ...(matchPath === "" ? ["/"] : ["/", `${matchPath}/`]),
              `${matchPath}/${patientRoute.route}`,
            ] // Make the first route the default landing page
          : `${matchPath}/${patientRoute.route}`,
      [matchPath, termsAgreed],
    );

    const toNavigationRoute = useCallback(
      (patientRoute, index) => (
        <Route
          key={patientRoute.route}
          path={pathByIndex(patientRoute, index)}
          exact
          render={() => (
            <Slide
              style={{ height: "100%" }}
              direction={"down"}
              in
              mountOnEnter
              unmountOnExit
            >
              <div>
                <patientRoute.component embedded={embedded} match={match} />
              </div>
            </Slide>
          )}
        />
      ),
      [pathByIndex, embedded, match],
    );

    return <Switch>{PatientRouteSettings.map(toNavigationRoute)}</Switch>;
  },
);
